import React from 'react';
import {InfoSectionProps} from '../../InfoSectionLayout';
import {InfoSectionDescription} from '../../InfoSectionDescription/InfoSectionDescription';
import {Cell} from '../../../Layouts/Cell/Cell';
import {InfoSectionEvent} from '../../../../types/app-types';
import {IWixStyleFont} from '@wix/wixstores-client-core/dist/es/src/types/wix-sdk';
import {Tabs} from 'wix-ui-tpa/cssVars';
import {classes as stylableClasses} from './TabsInfoSectionTPA.st.css';
import s from './TabsInfoSectionTPA.scss';
import type {TabsAlignment} from 'wix-ui-tpa';

export enum TabsInfoSectionDataHook {
  Root = 'tabs-info-section-tpa',
  TabsHeader = 'tabs-info-section-header-tpa',
  Body = 'tabs-info-section-body-tpa',
}

interface TabsInfoSectionTPAState {
  currentActiveTabIndex: number;
}

export interface TabsInfoSectionTPAProps extends InfoSectionProps {
  handleBIEvent(BIEvent: InfoSectionEvent): void;
  tabFontStyle: IWixStyleFont;
  alignment: TabsAlignment;
  isRTL?: boolean;
}

export class TabsInfoSectionTPA extends React.Component<TabsInfoSectionTPAProps, TabsInfoSectionTPAState> {
  public state = {
    currentActiveTabIndex: 0,
  };

  private readonly handleTabClick = (index: number) => {
    const {handleBIEvent} = this.props;
    this.setState({currentActiveTabIndex: index});
    handleBIEvent({index, type: 'tabs'});
  };

  private readonly getTabItems = () => {
    const {infoSectionItems} = this.props;

    return infoSectionItems.map((tab) => ({
      id: tab.id,
      title: tab.title,
    }));
  };

  private readonly getCurrentTab = () => {
    const {infoSectionItems} = this.props;
    const {currentActiveTabIndex} = this.state;
    return infoSectionItems[currentActiveTabIndex];
  };

  private readonly renderTabContent = () => {
    const {isRTL} = this.props;
    const currentTab = this.getCurrentTab();

    return (
      currentTab && (
        <Cell
          key={this.state.currentActiveTabIndex}
          className={s.description}
          dataHook={TabsInfoSectionDataHook.Body}
          dir={isRTL ? 'rtl' : 'ltr'}>
          <InfoSectionDescription description={currentTab.description} index={currentTab.index} />
        </Cell>
      )
    );
  };

  public render(): JSX.Element {
    const {currentActiveTabIndex} = this.state;
    const {tabFontStyle, alignment} = this.props;
    const tabItems = this.getTabItems();

    return (
      <div data-hook={TabsInfoSectionDataHook.Root} className={s.container}>
        <Tabs
          className={stylableClasses.root}
          items={tabItems}
          activeTabIndex={currentActiveTabIndex}
          onTabClick={this.handleTabClick}
          data-hook={TabsInfoSectionDataHook.TabsHeader}
          key={`tabs-${JSON.stringify(tabFontStyle)}`}
          alignment={alignment}
        />
        {this.renderTabContent()}
      </div>
    );
  }
}
